import React, { useRef, useState } from 'react'
import { GridTable, GridController } from "@ctsu/ctsu-mui-grid";
import { getToken } from "@ctsu/loader";
import { useCurrentUser } from 'helpers/getAppConfig';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchMCParticipants,
  personRoleEnumSelector,
  saveSelectedPR,
  roleTypeLovSelector,
  fetchRoleNameLov,
  selectedMCSelector,
  roleNameLovSelector
} from 'stores/redux/slice/manageCommitte';
import CustonFilter from './CustonFilter';
import { CommaToPills } from 'components/Administration/PersonRoleSetup/RoleSetup';

const statusLov = [
  {
    label: "Active",
    value: "Active"
  },
  {
    label: "Inactive",
    value: "Inactive"
  }
];
function splitRoleName(roleName) {
  if (roleName && roleName.split) {
    const n = roleName.split(',')
    return {
      label: n[0].trim(),
      value: n[0].trim()
    }
  }
  return {
    label: roleName,
    value: roleName
  }
}

export function MatchingPersonRolesGrid({ refreshGrid }) {
  const dispatch = useDispatch();
  const rows = useSelector(personRoleEnumSelector);
  const selectedMC = useSelector(selectedMCSelector)
  const roleTypeLov = useSelector(roleTypeLovSelector);
  const roleNameLov = useSelector(roleNameLovSelector);
  const currentUser = useCurrentUser();
  const [roleNameKey, setRoleNameKey] = useState()

  const onRoleTypeInputChange = (option) => {
    dispatch(fetchRoleNameLov({ owner: selectedMC?.owner, objectType: option?.value }))
    setRoleNameKey(option?.value);

  };

  const gridController = useRef(GridController.createController());
  const columns = [
    {
      filter: true,
      label: "Role Type",
      name: "roleType",
      title: "Role Type",
      type: "custom-list",
      renderCustomFilter: () => (
        <CustonFilter
          name="roleType"
          label="roleType"
          depend="roleName"
          gridController={gridController}
          onChange={onRoleTypeInputChange}
          lov={Array.isArray(roleTypeLov) ? roleTypeLov?.map(x => ({ value: x, label: x })) : []}
        />
      )

    },
    {
      filter: true,
      label: "Role Name",
      name: "roleName",
      options: "",
      title: "Role Name",
      type: "custom-list",
      renderCustomFilter: () => (
        <CustonFilter
          name="roleName"
          label="roleName"
          key={roleNameKey}
          parent="roleType"
          selectedParent={roleNameKey}
          gridController={gridController}
          lov={Array.isArray(roleNameLov) ? roleNameLov?.map(x => splitRoleName(x)) : []}
        />
      )
    },
    {
      filter: true,
      label: "For Object Type",
      name: "forObjType",
      title: "For Object Type",
      renderCell: rowData => <CommaToPills data={rowData.forObjType} />,
    },
    {
      filter: true,
      label: "Status",
      name: "esysStatus",
      options: statusLov,
      title: "Status",
      type: "object"
    }
  ]
  return (
    <GridTable
      user={currentUser}
      id="roleId"
      rows={rows}
      title="Matching Person Roles ENUM"
      columns={columns}
      toPdf={false}
      filterable
      enableInfiniteScroll={false}
      sortable
      showFilterByDefault
      enableToolbar
      highlightRow={0}
      recordPerPage={10}
      getToken={getToken}
      tag="my-mcpr-browser"
      editable
      controller={gridController.current}
      rowEditable={() => false}
      editMode={false}
      allowAddRow
      addRowLabel="Matching Person Roles ENUM"
      addRowTitle="Add Matching Person Roles ENUM"
      defaultSorts={[{ field: "roleType", dir: "asc" }, { field: "roleName", dir: "asc" }]}
      customFilterButtons={() => (
        <button className="grid-fn-btn" onClick={() => refreshGrid()} type="button" title="Reset Filters">
          Reset Filters
        </button>
      )}
      onDataLoad={(res) => {
        if (res && res.data) {
          let selected = res.data[0];
          if (selected && selected.roleType) {
            dispatch(fetchMCParticipants({ forObjDbId: selected?.forObjDbId, roleId: selected?.roleId }));
            dispatch(saveSelectedPR(selected))
            gridController.current.highlightRow(0)
          } else {
            dispatch(fetchMCParticipants({}));
            dispatch(saveSelectedPR({}))
          }

        }
      }}
      onRowClicked={(rowData) => {
        if (rowData && rowData.roleType) {
          dispatch(fetchMCParticipants({ forObjDbId: rowData?.forObjDbId, roleId: rowData?.roleId }));
          dispatch(saveSelectedPR(rowData));
        } else {
          dispatch(fetchMCParticipants({}));
          dispatch(saveSelectedPR({}))
        }
      }}
    />
  )
}



export default function MatchingPersonRoles() {
  const [key, setKey] = useState(1)
  const { id = '' } = useSelector(selectedMCSelector)
  return (
    <MatchingPersonRolesGrid key={`${id}_${key}`} refreshGrid={() => setKey(key + 1)} />
  )
}


